import { render, staticRenderFns } from "./DocumentosOportunidade.vue?vue&type=template&id=62a0fd40&scoped=true"
import script from "./DocumentosOportunidade.vue?vue&type=script&lang=js"
export * from "./DocumentosOportunidade.vue?vue&type=script&lang=js"
import style0 from "./DocumentosOportunidade.vue?vue&type=style&index=0&id=62a0fd40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0fd40",
  null
  
)

export default component.exports